module.exports = __webpack_public_path__ + "img/qwen-format-paper-art.b8ab3e65.webp";